/** Canonical product units — shared by production ProductForm and onboarding editor. */
export const UNIT_OPTIONS = [
  'piece',
  'kg',
  'g',
  'ml',
  'l',
  'bottle',
  'box',
  'pack',
  'hour',
  'minute',
  'meter',
  'cm',
  'dozen',
  'set',
  'pair',
  'unit',
] as const;
